/**
 * Normaliza y formatea la condición de pago para evitar duplicaciones
 * como "30 DÍAS DÍAS", "CONTADO días", etc.
 * 
 * @param {string|number} val - Valor original (ej: 0, 30, '30 DÍAS', 'CONTADO', '30 DÍAS DÍAS DÍAS')
 * @returns {string} - Condición formateada (ej: 'Contado', '30 días')
 */
export function formatPaymentCondition(val) {
  if (val === null || val === undefined || val === '') return 'Contado';
  let str = String(val).trim();
  if (str === '0') return 'Contado';
  if (!isNaN(str) && !isNaN(parseFloat(str))) {
    const num = parseInt(str, 10);
    return num === 0 ? 'Contado' : `${num} días`;
  }
  if (/^contado/i.test(str)) {
    return 'Contado';
  }
  const matchNum = str.match(/^(\d+)\s*(?:d[ií]as?\s*)+/i);
  if (matchNum) {
    const num = parseInt(matchNum[1], 10);
    return num === 0 ? 'Contado' : `${num} días`;
  }
  // Elimina repeticiones de la palabra días/dias
  str = str.replace(/(\b[dD][íÍiI][aA][sS]\b\s*)+/gi, 'días ').trim();
  return str;
}
